import _ from 'underscore';

var numberOfChanges = 0;
var listeners = [];

function unsubscribe(callback) {
    listeners = _.without(listeners, _.find(listeners, callback));
}

/**
 * A service that allowes clients to set, get and subscribe
 * to a number of changes in a shopping cart.
 *
 * Implements a very simple observable pattern
 *
 * @returns {Object}
 */
export default [function () {
    return {
        subscribe: function subscribe(callback) {
            listeners.push(callback);
            return unsubscribe.bind(null, callback);
        },
        set: function set(num) {
            numberOfChanges = num;
            if (listeners.length) {
                listeners.forEach(function (listener) {
                    listener(num);
                });
            }
        },
        get: function get() {
            return numberOfChanges;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/common/services/EndorsementNumberOfChanges.js
// module id = 1450
// module chunks = 0